<template>
  <div class="container-fluid principal">
    <div class="row">
      <div class="col-md-12">
        <Toast position="top-right" :baseZIndex="2222" />
        <Toolbar class="p-mb-4">
          <template #left>
            <Button
              label="Add"
              icon="pi pi-plus"
              class="p-button-success p-mr-2"
              @click="openNew"
            />
          </template>
          <template #right>
            <div v-if="profile == 'admin'" class="p-mr-2">
              <Button
                v-if="excel_cost_loaded"
                label="Costs"
                icon="pi pi-save"
                class="p-button-info p-mr-2"
                @click="generateExcelCostByShipper"
              />
              <ProgressSpinner
                v-else
                style="width: 50px; height: 50px"
                strokeWidth="8"
                fill="#EEEEEE"
                animationDuration=".5s"
              />
            </div>
            <div class="p-mr-2">
              <Button
                v-if="excel_loaded"
                label="Excel"
                icon="pi pi-save"
                class="p-button-info p-mr-2"
                @click="generateExcel"
              />
              <ProgressSpinner
                v-else
                style="width: 50px; height: 50px"
                strokeWidth="8"
                fill="#EEEEEE"
                animationDuration=".5s"
              />
            </div>
          </template>
        </Toolbar>
        <DataTable
          :value="operations"
          :expandedRows.sync="expandedRows"
          :loading="principal_data_table_loading"
          class="p-datatable-striped p-datatable-sm"
          dataKey="operation_id"
          :scrollable="true"
          :paginator="true"
          :rows="25"
          :filters="filters"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[25, 50, 75, 150, 300]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} operations"
          editMode="row"
          :editingRows.sync="editingPrincipalRows"
          @row-edit-init="onRowEditPrincipalInit"
          @row-edit-cancel="onRowEditPrincipalCancel"
          @row-edit-save="onRowEditPrincipalSave"
        >
          <template #header>
            <div class="table-header-container">
              <h5 class="p-m-0">Operations</h5>
              <div class="row">
                <div class="col-md-3">
                  <span class="p-input-icon-left">
                    <i class="pi pi-search" />
                    <InputText
                      v-model="filters['global']"
                      placeholder="Search..."
                      class="input-search-width"
                    />
                  </span>
                </div>
                <div class="col-md-3">
                  <Dropdown
                    v-model="filter_by_operation_status"
                    class="input-filter-by-status"
                    :options="dropdown_operation_status"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Choose a state of operation"
                    @change="getOperations"
                  >
                    <template #option="slotProps">
                      <span>{{ slotProps.option.label }}</span>
                    </template> </Dropdown
                  ><br />
                  <small>Operation Status. </small>
                </div>
                <div class="col-md-3">
                  <Dropdown
                    v-model="filter_by_company"
                    class="input-filter-by-company"
                    :options="dropdown_filter_by_company"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Choose a company"
                    @change="filterCompanySelected"
                    :showClear="true"
                  >
                    <template #option="slotProps">
                      <span>{{ slotProps.option.label }}</span>
                    </template> </Dropdown
                  ><br />
                  <small>Company. </small>
                </div>
                <div v-if="filter_expat_loaded" class="col-md-3">
                  <Dropdown
                    v-model="filter_by_expat"
                    class="input-filter-by-expat"
                    :options="dropdown_filter_by_expat"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Choose an expat"
                    @change="filterExpatSelected"
                    :showClear="true"
                  >
                    <template #option="slotProps">
                      <span>{{ slotProps.option.label }}</span>
                    </template> </Dropdown
                  ><br />
                  <small>Expat. </small>
                </div>
                <div class="col-md-3">
                  <Calendar
                    id="range"
                    v-model="selected_range_eta"
                    dateFormat="dd-mm-yy"
                    selectionMode="range"
                    :manualInput="false"
                    :showButtonBar="true"
                    :hideOnDateTimeSelect="true"
                    :showIcon="true"
                    @date-select="selectedRangeEta"
                    @clear-click="clearRangeEta"
                  /><br />
                  <small>Select Range Eta.</small>
                </div>
              </div>
            </div>
          </template>
          <Column
            :expander="true"
            headerStyle="text-align: center;width: 3rem"
          />
          <template v-for="col of selected_columns">
            <Column
              v-if="col.field == 'operation_id'"
              :field="col.field"
              :key="col.field"
              headerStyle="text-align: center;width: 130px"
              bodyStyle="text-align: center;width: 130px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.operation_id == ''"
                  class="p-sortable-column"
                  @click="
                    sortPrincipalDataTable(
                      'operation_id',
                      'operation_id',
                      sorted_by.operation_id
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.operation_id == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortPrincipalDataTable(
                      'operation_id',
                      'operation_id',
                      sorted_by.operation_id
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="
                      p-highlight p-sortable-column-icon
                      pi pi-fw pi-sort-amount-up-alt
                    "
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.operation_id == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortPrincipalDataTable(
                      'operation_id',
                      'operation_id',
                      sorted_by.operation_id
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'operation_dispatch'"
              :field="col.field"
              :key="col.field"
              headerStyle="text-align: center;width: 110px"
              bodyStyle="text-align: center;width: 110px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.operation_dispatch == ''"
                  class="p-sortable-column"
                  @click="
                    sortPrincipalDataTable(
                      'operation_dispatch',
                      'operation_dispatch',
                      sorted_by.operation_dispatch
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.operation_dispatch == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortPrincipalDataTable(
                      'operation_dispatch',
                      'operation_dispatch',
                      sorted_by.operation_dispatch
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="
                      p-highlight p-sortable-column-icon
                      pi pi-fw pi-sort-amount-up-alt
                    "
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.operation_dispatch == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortPrincipalDataTable(
                      'operation_dispatch',
                      'operation_dispatch',
                      sorted_by.operation_dispatch
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>
              <template #editor="slotProps">
                <InputText
                  v-model="slotProps.data[slotProps.column.field]"
                  class="input-full-width"
                />
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'shipper_id'"
              :field="'shipper_details.shipper_name'"
              :key="col.field"
              headerStyle="text-align: center;width: 100px"
              bodyStyle="text-align: center;width: 100px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.shipper_details_shipper_name == ''"
                  class="p-sortable-column"
                  @click="
                    sortPrincipalDataTable(
                      'shipper_details.shipper_name',
                      'shipper_details_shipper_name',
                      sorted_by.shipper_details_shipper_name
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.shipper_details_shipper_name == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortPrincipalDataTable(
                      'shipper_details.shipper_name',
                      'shipper_details_shipper_name',
                      sorted_by.shipper_details_shipper_name
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="
                      p-highlight p-sortable-column-icon
                      pi pi-fw pi-sort-amount-up-alt
                    "
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.shipper_details_shipper_name == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortPrincipalDataTable(
                      'shipper_details.shipper_name',
                      'shipper_details_shipper_name',
                      sorted_by.shipper_details_shipper_name
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>

              <template #editor="slotProps">
                <Dropdown
                  v-model="slotProps.data['shipper_id']"
                  class="input-full-width"
                  :options="shippers"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Choose a shipper"
                >
                  <template #option="slotProps">
                    <span>{{ slotProps.option.label }}</span>
                  </template>
                </Dropdown>
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'company_id'"
              :field="'company_details.company_name'"
              :key="col.field"
              headerStyle="text-align: center;width: 290px"
              bodyStyle="text-align: center;width: 290px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.company_details_company_name == ''"
                  class="p-sortable-column"
                  @click="
                    sortPrincipalDataTable(
                      'company_details.company_name',
                      'company_details_company_name',
                      sorted_by.company_details_company_name
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.company_details_company_name == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortPrincipalDataTable(
                      'company_details.company_name',
                      'company_details_company_name',
                      sorted_by.company_details_company_name
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="
                      p-highlight p-sortable-column-icon
                      pi pi-fw pi-sort-amount-up-alt
                    "
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.company_details_company_name == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortPrincipalDataTable(
                      'company_details.company_name',
                      'company_details_company_name',
                      sorted_by.company_details_company_name
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>
              <template #body="slotProps">
                <span
                  v-if="
                    slotProps.data.operation_company_tag.toString().length > 0
                  "
                >
                  {{ slotProps.data.company_details.company_name + "  " }}
                  <Tag
                    :value="'# ' + slotProps.data.operation_company_tag"
                    severity="info"
                    :rounded="true"
                  >
                  </Tag>
                  <Tag
                    class="tag_margin_left"
                    :value="slotProps.data.company_details.company_code"
                    severity="warning"
                    :rounded="true"
                  >
                  </Tag>
                </span>
                <span v-else>
                  {{ slotProps.data.company_details.company_name }}
                  <Tag
                    :value="slotProps.data.company_details.company_code"
                    severity="warning"
                    :rounded="true"
                  >
                  </Tag>
                </span>
              </template>
              <template #editor="slotProps">
                <Dropdown
                  v-model="company_id_to_edit"
                  class="input-full-width"
                  :options="companies"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Choose a company"
                  :filter="true"
                  emptyFilterMessage="No results found"
                  @input="getExpatsToEdit"
                >
                  <template #option="slotProps">
                    <span>{{ slotProps.option.label }}</span>
                  </template>
                </Dropdown>
                <br />
                <br />

                <Checkbox id="edit_tag" v-model="edit_tag" :binary="true" />
                <label for="edit_tag" style="display: initial"> Add Tag </label>
                <br /><br />
                <InputNumber
                  v-if="edit_tag"
                  v-model="slotProps.data['operation_company_tag']"
                  inputStyle="width: 75px"
                  prefix="# "
                  mode="decimal"
                  showButtons
                  :min="1"
                  :max="1000"
                />
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'expat_id'"
              :field="'expat_details.expat_name'"
              :key="col.field"
              headerStyle="text-align: center;width: 170px"
              bodyStyle="text-align: center;width: 170px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.expat_details_expat_name == ''"
                  class="p-sortable-column"
                  @click="
                    sortPrincipalDataTable(
                      'expat_details.expat_name',
                      'expat_details_expat_name',
                      sorted_by.expat_details_expat_name
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.expat_details_expat_name == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortPrincipalDataTable(
                      'expat_details.expat_name',
                      'expat_details_expat_name',
                      sorted_by.expat_details_expat_name
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="
                      p-highlight p-sortable-column-icon
                      pi pi-fw pi-sort-amount-up-alt
                    "
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.expat_details_expat_name == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortPrincipalDataTable(
                      'expat_details.expat_name',
                      'expat_details_expat_name',
                      sorted_by.expat_details_expat_name
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span>
                </span>
              </template>
              <template #editor="slotProps">
                <Dropdown
                  v-if="expat_loaded"
                  v-model="slotProps.data['expat_id']"
                  class="input-full-width"
                  :options="expats"
                  :filter="true"
                  emptyFilterMessage="No results found"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Choose an expat"
                >
                  <template #option="slotProps">
                    <span>{{ slotProps.option.label }}</span>
                  </template>
                </Dropdown>
                <ProgressSpinner
                  v-else
                  style="width: 50px; height: 50px"
                  strokeWidth="8"
                  fill="#EEEEEE"
                  animationDuration=".5s"
                />
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'operation_ata'"
              :field="col.field"
              :key="col.field"
              headerStyle="text-align: center;width: 100px"
              bodyStyle="text-align: center;width: 100px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.operation_ata == ''"
                  class="p-sortable-column"
                  @click="
                    sortPrincipalDataTable(
                      'operation_ata',
                      'operation_ata',
                      sorted_by.operation_ata
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.operation_ata == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortPrincipalDataTable(
                      'operation_ata',
                      'operation_ata',
                      sorted_by.operation_ata
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="
                      p-highlight p-sortable-column-icon
                      pi pi-fw pi-sort-amount-up-alt
                    "
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.operation_ata == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortPrincipalDataTable(
                      'operation_ata',
                      'operation_ata',
                      sorted_by.operation_ata
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>

              <template #editor="slotProps">
                <Calendar
                  v-model="slotProps.data[slotProps.column.field]"
                  dateFormat="dd-mm-yy"
                  :showIcon="true"
                  :manualInput="false"
                />
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'operation_m_awb'"
              :field="col.field"
              :key="col.field"
              headerStyle="text-align: center;width: 115px"
              bodyStyle="text-align: center;width: 115px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.operation_m_awb == ''"
                  class="p-sortable-column"
                  @click="
                    sortPrincipalDataTable(
                      'operation_m_awb',
                      'operation_m_awb',
                      sorted_by.operation_m_awb
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.operation_m_awb == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortPrincipalDataTable(
                      'operation_m_awb',
                      'operation_m_awb',
                      sorted_by.operation_m_awb
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="
                      p-highlight p-sortable-column-icon
                      pi pi-fw pi-sort-amount-up-alt
                    "
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.operation_m_awb == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortPrincipalDataTable(
                      'operation_m_awb',
                      'operation_m_awb',
                      sorted_by.operation_m_awb
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>

              <template #editor="slotProps">
                <InputText
                  v-model="slotProps.data[slotProps.column.field]"
                  class="input-full-width"
                />
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'operation_h_awb'"
              :field="col.field"
              :key="col.field"
              headerStyle="text-align: center;width: 115px"
              bodyStyle="text-align: center;width: 115px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.operation_h_awb == ''"
                  class="p-sortable-column"
                  @click="
                    sortPrincipalDataTable(
                      'operation_h_awb',
                      'operation_h_awb',
                      sorted_by.operation_h_awb
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.operation_h_awb == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortPrincipalDataTable(
                      'operation_h_awb',
                      'operation_h_awb',
                      sorted_by.operation_h_awb
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="
                      p-highlight p-sortable-column-icon
                      pi pi-fw pi-sort-amount-up-alt
                    "
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.operation_h_awb == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortPrincipalDataTable(
                      'operation_h_awb',
                      'operation_h_awb',
                      sorted_by.operation_h_awb
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>
              <template #editor="slotProps">
                <InputText
                  v-model="slotProps.data[slotProps.column.field]"
                  class="input-full-width"
                />
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'operation_status'"
              :header="col.header"
              :field="col.field"
              :key="col.field"
              headerStyle="text-align: center;width: 100px"
              bodyStyle="text-align: center;width: 100px;"
            >
              <template #body="slotProps">
                <span
                  v-if="slotProps.data.operation_status == 'Abierta'"
                  class="label-success-status"
                >
                  {{ slotProps.data.operation_status }}
                </span>
                <span v-else class="label-success-warning">
                  {{ slotProps.data.operation_status }}
                </span>
              </template>
              <template #editor="slotProps">
                <span
                  v-if="slotProps.data.operation_status == 'Abierta'"
                  class="label-success-status"
                >
                  {{ slotProps.data.operation_status }}
                </span>
                <span v-else class="label-success-warning">
                  {{ slotProps.data.operation_status }}
                </span>
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'actions' && can_show_actions"
              headerStyle="text-align: center;width: 7rem"
              bodyStyle="text-align: center;width: 7rem; text-align: center;"
              :key="col.field"
            >
              <template #body="slotProps">
                <Button
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger button-margin-right"
                  @click="confirmDeleteOperation(slotProps.data)"
                />

                <Button
                  v-if="slotProps.data.operation_status == 'Abierta'"
                  icon="pi pi-lock"
                  class="p-button-rounded p-button-danger"
                  @click="confirmCloseOperation(slotProps.data)"
                />
                <Button
                  v-else
                  icon="pi pi-lock-open"
                  class="p-button-rounded p-button-success"
                  @click="confirmOpenOperation(slotProps.data)"
                />
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'editPrincipal'"
              :rowEditor="true"
              headerStyle="text-align: center;width: 7rem"
              bodyStyle="text-align: center;width: 7rem; text-align:center;"
              :key="col.field"
            >
            </Column>
          </template>
          <template #expansion="slotProps">
            <div class="operations-import">
              <h5><b> OPERATIONS</b></h5>
              <DataTable
                :value="[slotProps.data]"
                class="operations-import-datatable p-datatable-sm"
                editMode="row"
                :editingRows.sync="editingImportRows"
                @row-edit-init="onRowEditImportInit"
                @row-edit-cancel="onRowEditImportCancel"
                @row-edit-save="onRowEditImportSave"
              >
                <template v-for="col of selected_columns">
                  <Column
                    v-if="col.field == 'operation_traduction'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-import-columns-status-body"
                    headerClass="operations-import-columns-status-header"
                  >
                    <template #body="slotProps">
                      <span v-if="slotProps.data.operation_traduction">
                        <Avatar shape="circle" class="avatar-green">
                          <i class="pi pi-check-circle icon-white"></i>
                        </Avatar>
                      </span>
                      <span v-else>
                        <Avatar shape="circle" class="avatar-red">
                          <i class="pi pi-times-circle icon-white"></i>
                        </Avatar>
                      </span>
                    </template>
                    <template #editor="slotProps">
                      <InputSwitch
                        v-model="slotProps.data[slotProps.column.field]"
                      />
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'operation_pre_alerted'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-import-columns-status-body"
                    headerClass="operations-import-columns-status-header"
                  >
                    <template #body="slotProps">
                      <span v-if="slotProps.data.operation_pre_alerted">
                        <Avatar shape="circle" class="avatar-green">
                          <i class="pi pi-check-circle icon-white"></i>
                        </Avatar>
                      </span>
                      <span v-else>
                        <Avatar shape="circle" class="avatar-red">
                          <i class="pi pi-times-circle icon-white"></i>
                        </Avatar>
                      </span>
                    </template>

                    <template #editor="slotProps">
                      <InputSwitch
                        v-model="slotProps.data[slotProps.column.field]"
                      />
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'operation_status_arrival'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-import-columns-body"
                    headerClass="operations-import-columns-header"
                    ><template #body="slotProps">
                      <span
                        v-if="
                          slotProps.data.operation_status_arrival == 'Arribado'
                        "
                        class="label-success-status"
                      >
                        {{ slotProps.data.operation_status_arrival }}
                      </span>
                      <span v-else class="label-success-info">
                        {{ slotProps.data.operation_status_arrival }}
                      </span>
                    </template>

                    <template #editor="slotProps">
                      <Dropdown
                        v-model="slotProps.data['operation_status_arrival']"
                        class="input-full-width"
                        :options="status_arrival_dropdown"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Choose a status"
                      >
                        <template #option="slotProps">
                          <span>{{ slotProps.option.label }}</span>
                        </template>
                      </Dropdown>
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'operation_endorsed'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-import-columns-status-body"
                    headerClass="operations-import-columns-status-header"
                  >
                    <template #body="slotProps">
                      <span v-if="slotProps.data.operation_endorsed">
                        <Avatar shape="circle" class="avatar-green">
                          <i class="pi pi-check-circle icon-white"></i>
                        </Avatar>
                      </span>
                      <span v-else>
                        <Avatar shape="circle" class="avatar-red">
                          <i class="pi pi-times-circle icon-white"></i>
                        </Avatar>
                      </span>
                    </template>

                    <template #editor="slotProps">
                      <InputSwitch
                        v-model="slotProps.data[slotProps.column.field]"
                      />
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'operation_imported'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-import-columns-status-body"
                    headerClass="operations-import-columns-status-header"
                  >
                    <template #body="slotProps">
                      <span v-if="slotProps.data.operation_imported">
                        <Avatar shape="circle" class="avatar-green">
                          <i class="pi pi-check-circle icon-white"></i>
                        </Avatar>
                      </span>
                      <span v-else>
                        <Avatar shape="circle" class="avatar-red">
                          <i class="pi pi-times-circle icon-white"></i>
                        </Avatar>
                      </span>
                    </template>

                    <template #editor="slotProps">
                      <InputSwitch
                        v-model="slotProps.data[slotProps.column.field]"
                      />
                    </template>
                  </Column>
                  <Column
                    v-if="col.field == 'operation_delivery'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-delivery-columns-body"
                    headerClass="operations-delivery-columns-header"
                  >
                    <template #editor="slotProps">
                      <Calendar
                        v-model="slotProps.data[slotProps.column.field]"
                        dateFormat="dd-mm-yy"
                        :showIcon="true"
                        :manualInput="false"
                      />
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'operation_destination'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-operation-destination-columns-body"
                    headerClass="operations-operation-destination-columns-header"
                  >
                    <template #editor="slotProps">
                      <InputText
                        v-model="slotProps.data[slotProps.column.field]"
                        class="input-full-width"
                      />
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'operation_direction'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-delivery-columns-direction-body"
                    headerClass="operations-delivery-columns-direction-header"
                  >
                    <template #editor="slotProps">
                      <InputText
                        v-model="slotProps.data[slotProps.column.field]"
                        class="input-full-width"
                      />
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'operation_status_delivery'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-delivery-columns-body"
                    headerClass="operations-delivery-columns-header"
                  >
                    <template #body="slotProps">
                      <span
                        v-if="
                          slotProps.data.operation_status_delivery ==
                          'Entregado'
                        "
                        class="label-success-status"
                      >
                        {{ slotProps.data.operation_status_delivery }}
                      </span>
                      <span v-else class="label-success-warning">
                        {{ slotProps.data.operation_status_delivery }}
                      </span>
                    </template>
                    <template #editor="slotProps">
                      <Dropdown
                        v-model="slotProps.data['operation_status_delivery']"
                        class="input-full-width"
                        :options="status_delivery_dropdown"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Choose a status"
                      >
                        <template #option="slotProps">
                          <span>{{ slotProps.option.label }}</span>
                        </template>
                      </Dropdown>
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'editImport'"
                    :rowEditor="true"
                    headerStyle="text-align: center;width: 7rem; background-color: #70ad47"
                    bodyStyle="text-align: center;width: 7rem; text-align:center; background-color: #e2efda"
                    :key="col.field"
                  ></Column>
                </template>
              </DataTable>
            </div>
            <div class="operations-post-venta">
              <h5><b> ACCOUNTING</b></h5>
              <DataTable
                :value="[slotProps.data]"
                class="operations-post-venta-datatable p-datatable-sm"
                editMode="row"
                :editingRows.sync="editingPostSalesRows"
                @row-edit-init="onRowEditPostSalesInit"
                @row-edit-cancel="onRowEditPostSalesCancel"
                @row-edit-save="onRowEditPostSalesSave"
              >
                <template v-for="col of selected_columns">
                  <Column
                    v-if="col.field == 'operation_status_invoiced_browne'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-post-venta-status-columns-body"
                    headerClass="operations-post-venta-status-columns-header"
                  >
                    <template #body="slotProps">
                      <span
                        v-if="slotProps.data.operation_status_invoiced_browne"
                      >
                        <Avatar shape="circle" class="avatar-green">
                          <i class="pi pi-check-circle icon-white"></i>
                        </Avatar>
                      </span>
                      <span v-else>
                        <Avatar shape="circle" class="avatar-red">
                          <i class="pi pi-times-circle icon-white"></i>
                        </Avatar>
                      </span>
                    </template>
                    <template #editor="slotProps">
                      <InputSwitch
                        v-model="slotProps.data[slotProps.column.field]"
                      />
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'operation_document_number'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-post-venta-operation-document-number-columns-body"
                    headerClass="operations-post-venta-operation-document-number-columns-header"
                  >
                    <template #editor="slotProps">
                      <InputNumber
                        v-model="slotProps.data[slotProps.column.field]"
                        mode="decimal"
                        :useGrouping="false"
                        inputClass="input-number-full-width"
                        :min="1"
                        :max="10000000000"
                      />
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'operation_agent_total_to_pay'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-post-venta-columns-body"
                    headerClass="operations-post-venta-columns-header"
                  >
                    <template #body="slotProps">
                      <span
                        v-if="
                          slotProps.data
                            .operation_agent_total_to_pay_currency_type == '$'
                        "
                      >
                        {{
                          slotProps.data
                            .operation_agent_total_to_pay_currency_type +
                          " " +
                          clpFormat(slotProps.data.operation_agent_total_to_pay)
                        }}
                      </span>

                      <span v-else>
                        {{
                          slotProps.data
                            .operation_agent_total_to_pay_currency_type +
                          " " +
                          eeuuFormat(
                            slotProps.data.operation_agent_total_to_pay
                          )
                        }}
                      </span>
                    </template>

                    <template #editor="slotProps">
                      <div
                        class="p-inputgroup"
                        v-if="
                          edit_operation_agent_total_to_pay_currency_type ==
                            '$' ||
                          edit_operation_agent_total_to_pay_currency_type !=
                            'USD'
                        "
                      >
                        <Button
                          icon="pi pi-money-bill"
                          class="p-button-success"
                          @click="
                            change_operation_agent_total_to_pay_currency_type(
                              '$'
                            )
                          "
                        />
                        <InputNumber
                          v-model="slotProps.data[slotProps.column.field]"
                          mode="decimal"
                          :useGrouping="true"
                          prefix="$ "
                          inputClass="input-number-full-width"
                          :min="1"
                          :max="100000000000"
                        />
                      </div>

                      <div
                        v-else-if="
                          edit_operation_agent_total_to_pay_currency_type ==
                          'USD'
                        "
                        class="p-inputgroup"
                      >
                        <Button
                          icon="pi pi-money-bill"
                          class="p-button-success"
                          @click="
                            change_operation_agent_total_to_pay_currency_type(
                              'USD'
                            )
                          "
                        />
                        <!-- <InputNumber
                          v-model="slotProps.data[slotProps.column.field]"
                          mode="decimal"
                          locale="en-US"
                          prefix="USD "
                          inputClass="input-number-full-width"
                          :minFractionDigits="2"
                          :maxFractionDigits="2"
                          :min="1"
                          :max="100000000000"
                        /> -->
                        <span class="p-inputgroup-addon">USD</span>
                        <InputText
                          v-model="slotProps.data[slotProps.column.field]"
                          inputClass="input-number-full-width"
                          @input="
                            dolarValidation(
                              slotProps.data[slotProps.column.field]
                            )
                          "
                        />
                      </div>
                      <div v-if="dolar_validation_error">
                        <br />
                        <h6 class="red-color">
                          Please enter a numeric value. <br />
                          Only a maximum of 2 decimal places separated by a
                          point are accepted.
                        </h6>
                        <h6 class="red-color">
                          For Example: <br />
                          1500.44 <br />
                          1500
                        </h6>
                      </div>
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'operation_perrot'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-post-venta-columns-body"
                    headerClass="operations-post-venta-columns-header"
                  >
                    <template #editor="slotProps">
                      <InputNumber
                        v-model="slotProps.data[slotProps.column.field]"
                        mode="decimal"
                        :useGrouping="false"
                        inputClass="input-number-full-width"
                        :min="1"
                        :max="10000000000"
                      />
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'operation_perrot_total_to_pay'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-post-venta-columns-body"
                    headerClass="operations-post-venta-columns-header"
                  >
                    <template #body="slotProps">
                      <span>
                        {{
                          "$ " +
                          clpFormat(
                            slotProps.data.operation_perrot_total_to_pay
                          )
                        }}
                      </span>
                    </template>
                    <template #editor="slotProps">
                      <InputText
                        v-if="
                          slotProps.data
                            .operation_perrot_total_to_pay_currency_type == '$'
                        "
                        v-model="slotProps.data[slotProps.column.field]"
                        inputClass="input-number-full-width"
                        @click="
                          clearInput(
                            slotProps.data['operation_id'],
                            slotProps.column.field,
                            slotProps.data[slotProps.column.field]
                          )
                        "
                        @input="
                          clpValidation4(slotProps.data[slotProps.column.field])
                        "
                      />
                      <InputNumber
                        v-else
                        v-model="slotProps.data[slotProps.column.field]"
                        mode="decimal"
                        :useGrouping="true"
                        prefix="$ "
                        inputClass="input-number-full-width"
                        :min="1"
                        :max="100000000000"
                      />
                      <div v-if="clp_validation4_error">
                        <br />
                        <h6 class="red-color">
                          Please enter a numeric value. <br />
                        </h6>
                        <h6 class="red-color">
                          For Example: <br />
                          450455 <br />
                          150000
                        </h6>
                      </div>
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'editPostSales'"
                    :rowEditor="true"
                    headerStyle="text-align: center;width: 7rem; background-color: #ffc000"
                    bodyStyle="text-align: center;width: 7rem; text-align:center; background-color: #fff2cc"
                    :key="col.field"
                  >
                  </Column>
                </template>
              </DataTable>
            </div>
            <div v-if="profile == 'admin'" class="operations-accounting">
              <h5><b> MANAGEMENT</b></h5>
              <DataTable
                :value="[slotProps.data]"
                class="operations-accounting-datatable p-datatable-sm"
                editMode="row"
                :editingRows.sync="editingAccountingRows"
                @row-edit-init="onRowEditAccountingInit"
                @row-edit-cancel="onRowEditAccountingCancel"
                @row-edit-save="onRowEditAccountingSave"
              >
                <template v-for="col of selected_columns">
                  <Column
                    v-if="col.field == 'operation_cost'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-accounting-columns-body"
                    headerClass="operations-accounting-columns-header"
                  >
                    <template #body="slotProps">
                      <span>
                        {{ "$ " + clpFormat(slotProps.data.operation_cost) }}
                      </span>
                    </template>
                    <template #editor="slotProps">
                      <InputText
                        v-if="
                          slotProps.data.operation_cost_currency_type == '$'
                        "
                        v-model="slotProps.data[slotProps.column.field]"
                        inputClass="input-number-full-width"
                        @click="
                          clearInput(
                            slotProps.data['operation_id'],
                            slotProps.column.field,
                            slotProps.data[slotProps.column.field]
                          )
                        "
                        @input="
                          clpValidation3(slotProps.data[slotProps.column.field])
                        "
                      />
                      <InputNumber
                        v-else
                        v-model="slotProps.data[slotProps.column.field]"
                        mode="decimal"
                        :useGrouping="true"
                        prefix="$ "
                        inputClass="input-number-full-width"
                        :min="1"
                        :max="100000000000"
                      />
                      <div v-if="clp_validation3_error">
                        <br />
                        <h6 class="red-color">
                          Please enter a numeric value. <br />
                        </h6>
                        <h6 class="red-color">
                          For Example: <br />
                          450455 <br />
                          150000
                        </h6>
                      </div>
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'operation_status_invoiced_client'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-accounting-status-columns-body"
                    headerClass="operations-accounting-status-columns-header"
                  >
                    <template #body="slotProps">
                      <span
                        v-if="slotProps.data.operation_status_invoiced_client"
                      >
                        <Avatar shape="circle" class="avatar-green">
                          <i class="pi pi-check-circle icon-white"></i>
                        </Avatar>
                      </span>
                      <span v-else>
                        <Avatar shape="circle" class="avatar-red">
                          <i class="pi pi-times-circle icon-white"></i>
                        </Avatar>
                      </span>
                    </template>
                    <template #editor="slotProps">
                      <InputSwitch
                        v-model="slotProps.data[slotProps.column.field]"
                      />
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'operation_invoice_or_debit_note'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-accounting-operation-document-number-columns-body"
                    headerClass="operations-accounting-operation-document-number-columns-header"
                  >
                    <template #editor="slotProps">
                      <InputText
                        v-model="slotProps.data[slotProps.column.field]"
                        class="input-full-width"
                      />
                    </template>
                  </Column>
                  <Column
                    v-else-if="
                      col.field == 'operation_invoice_or_debit_note_type'
                    "
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-accounting-operation-document-number-columns-body"
                    headerClass="operations-accounting-operation-document-number-columns-header"
                  >
                    <template #editor="slotProps">
                      <Dropdown
                        v-model="slotProps.data[slotProps.column.field]"
                        class="input-full-width"
                        :options="dropdown_operation_invoice_or_debit_note_type"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Choose a type"
                        @input="
                          operationInvoiceOrDebitNoteTypeInput(
                            slotProps.data[slotProps.column.field]
                          )
                        "
                      >
                        <template #option="slotProps">
                          <span>{{ slotProps.option.label }}</span>
                        </template>
                      </Dropdown>
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'operation_total_to_pay'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-accounting-columns-body"
                    headerClass="operations-accounting-columns-header"
                  >
                    <template #body="slotProps">
                      <span
                        v-if="
                          slotProps.data.operation_total_to_pay_currency_type ==
                          '$'
                        "
                      >
                        {{
                          slotProps.data.operation_total_to_pay_currency_type +
                          " " +
                          clpFormat(slotProps.data.operation_total_to_pay)
                        }}
                      </span>
                      <span v-else>
                        {{
                          slotProps.data.operation_total_to_pay_currency_type +
                          " " +
                          eeuuFormat(slotProps.data.operation_total_to_pay)
                        }}
                      </span>
                    </template>
                    <template #editor="slotProps">
                      <div
                        class="p-inputgroup"
                        v-if="
                          edit_operation_total_to_pay_currency_type == '$' ||
                          edit_operation_total_to_pay_currency_type != 'USD'
                        "
                      >
                        <Button
                          icon="pi pi-money-bill"
                          class="p-button-success"
                          @click="
                            change_operation_total_to_pay_currency_type('$')
                          "
                        />

                        <span class="p-inputgroup-addon">$</span>
                        <InputText
                          v-model="slotProps.data[slotProps.column.field]"
                          inputClass="input-number-full-width"
                          @click="
                            clearInput(
                              slotProps.data['operation_id'],
                              slotProps.column.field,
                              slotProps.data[slotProps.column.field]
                            )
                          "
                          @input="
                            clpValidation2(
                              slotProps.data[slotProps.column.field]
                            )
                          "
                        />
                      </div>
                      <div v-if="clp_validation2_error">
                        <br />
                        <h6 class="red-color">
                          Please enter a numeric value. <br />
                        </h6>
                        <h6 class="red-color">
                          For Example: <br />
                          450455 <br />
                          150000
                        </h6>
                      </div>
                      <div
                        v-else-if="
                          edit_operation_total_to_pay_currency_type == 'USD'
                        "
                        class="p-inputgroup"
                      >
                        <Button
                          icon="pi pi-money-bill"
                          class="p-button-success"
                          @click="
                            change_operation_total_to_pay_currency_type('USD')
                          "
                        />
                        <!-- <InputNumber
                          v-model="slotProps.data[slotProps.column.field]"
                          mode="decimal"
                          locale="en-US"
                          inputClass="input-number-full-width"
                          prefix="USD "
                          :min="1"
                          :max="100000000000"
                          :minFractionDigits="2"
                          :maxFractionDigits="2"
                        /> -->
                        <span class="p-inputgroup-addon">USD</span>
                        <InputText
                          v-model="slotProps.data[slotProps.column.field]"
                          inputClass="input-number-full-width"
                          @click="
                            clearInput(
                              slotProps.data['operation_id'],
                              slotProps.column.field,
                              slotProps.data[slotProps.column.field]
                            )
                          "
                          @input="
                            dolarValidation(
                              slotProps.data[slotProps.column.field]
                            )
                          "
                        />
                      </div>
                      <div v-if="dolar_validation_error">
                        <br />
                        <h6 class="red-color">
                          Please enter a numeric value. <br />
                          Only a maximum of 2 decimal places separated by a
                          point are accepted.
                        </h6>
                        <h6 class="red-color">
                          For Example: <br />
                          1500.44 <br />
                          1500
                        </h6>
                      </div>
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'operation_profit'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-accounting-operation-profit-columns-body"
                    headerClass="operations-accounting-operation-profit-columns-header"
                  >
                    <template #body="slotProps">
                      <span>
                        {{ "$ " + clpFormat(slotProps.data.operation_profit) }}
                      </span>
                    </template>
                    <template #editor="slotProps">
                      <span>
                        {{ "$ " + clpFormat(slotProps.data.operation_profit) }}
                      </span>
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'operation_dolar_profit'"
                    :field="col.field"
                    :header="col.header"
                    :key="col.field"
                    bodyClass="operations-accounting-operation-profit-columns-body"
                    headerClass="operations-accounting-operation-profit-columns-header"
                  >
                    <template #body="slotProps">
                      <span>
                        {{ "$ " + slotProps.data.operation_dolar_profit }}
                      </span>
                    </template>
                    <template #editor="slotProps">
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                          <i class="pi pi-dollar"></i>
                        </span>
                        <InputText
                          v-model="slotProps.data['operation_dolar_profit']"
                          inputClass="input-number-full-width"
                          @click="
                            clearInput(
                              slotProps.data['operation_id'],
                              'operation_dolar_profit',
                              slotProps.data['operation_dolar_profit']
                            )
                          "
                          @input="
                            clpValidation(
                              slotProps.data[slotProps.column.field]
                            )
                          "
                        />
                      </div>
                      <div v-if="clp_validation_error">
                        <br />
                        <h6 class="red-color">
                          Please enter a numeric value. <br />
                          Only a maximum of 2 decimal places separated by a
                          comma are accepted.
                        </h6>
                        <h6 class="red-color">
                          For Example: <br />
                          734,44 <br />
                          734
                        </h6>
                      </div>
                    </template>
                  </Column>
                  <Column
                    v-else-if="col.field == 'editAccounting'"
                    :rowEditor="true"
                    headerStyle="text-align: center;width: 7rem; background-color: #00d9ff"
                    bodyStyle="text-align: center;width: 7rem; text-align:center; background-color: #ccf5ff"
                    :key="col.field"
                  >
                  </Column>
                </template>
              </DataTable>
            </div>
            <!-- <div class="operations-proofit">
              <h5><b> Profit</b></h5>
              {{slotProps.data.operation_id}}
            </div> -->
          </template>
        </DataTable>
        <Dialog
          :baseZIndex="2222"
          :visible.sync="createOperationDialog"
          :style="{ width: '475px' }"
          header="Nueva Operación"
          :modal="true"
          :maximizable="true"
          position="center"
          class="p-fluid"
        >
          <div class="p-field">
            <label for="company_id">Empresa</label>
            <br />
            <Dropdown
              id="company_id"
              v-model="newOperation.company_id"
              class="input-full-width"
              :options="companies"
              optionLabel="label"
              optionValue="value"
              :filter="true"
              emptyFilterMessage="No results found"
              placeholder="Choose a company"
              @input="getExpatsToAdd"
            >
              <template #option="slotProps">
                <span>{{ slotProps.option.label }}</span>
              </template>
            </Dropdown>
            <small
              class="p-invalid"
              v-if="newOperationSubmitted && invalid.company_id"
              >Please complete this field. </small
            ><br />
            <Checkbox
              id="create_tag"
              v-model="create_tag"
              :binary="true"
              @change="createTag"
            />
            <label for="create_tag" style="display: initial"> Add Tag</label>
            <br /><br />
          </div>
          <div v-if="create_tag" class="p-field">
            <InputNumber
              v-model="newOperation.operation_company_tag"
              inputStyle="width: 75px"
              prefix="# "
              mode="decimal"
              showButtons
              :min="1"
              :max="1000"
            />
            <small
              class="p-invalid"
              v-if="newOperationSubmitted && invalid.operation_company_tag"
              >Please complete this field.
            </small>
            <br /><br />
          </div>
          <div v-if="show_expat_to_add" class="p-field">
            <label for="expat_id">Expat</label>
            <br />
            <Dropdown
              id="expat_id"
              v-if="expat_loaded"
              v-model="newOperation.expat_id"
              class="input-full-width"
              :options="expats"
              optionLabel="label"
              optionValue="value"
              :filter="true"
              emptyFilterMessage="No results found"
              placeholder="Choose an expat"
            >
              <template #option="slotProps">
                <span>{{ slotProps.option.label }}</span>
              </template>
            </Dropdown>

            <small
              class="p-invalid"
              v-if="newOperationSubmitted && invalid.expat_id"
              >Please complete this field.
            </small>
            <br />
          </div>
          <div class="p-field">
            <label for="shipper_id">Shipper</label>
            <br />
            <Dropdown
              id="shipper_id"
              v-model="newOperation.shipper_id"
              class="input-full-width"
              :options="shippers"
              optionLabel="label"
              optionValue="value"
              placeholder="Choose a shipper"
            >
              <template #option="slotProps">
                <span>{{ slotProps.option.label }}</span>
              </template>
            </Dropdown>
            <small
              class="p-invalid"
              v-if="newOperationSubmitted && invalid.shipper_id"
              >Please complete this field.
            </small>
            <br />
          </div>
          <div class="p-field">
            <label for="operation_ata">Eta</label>
            <Calendar
              id="operation_ata"
              v-model="newOperation.operation_ata"
              dateFormat="dd-mm-yy"
              :showIcon="true"
              :manualInput="false"
            />

            <small
              class="p-invalid"
              v-if="newOperationSubmitted && invalid.operation_ata"
              >Please complete this field.
            </small>
            <br />
          </div>
          <div class="p-field">
            <label for="operation_m_awb">(M)AWB</label>
            <br />
            <InputText
              id="operation_m_awb"
              v-model="newOperation.operation_m_awb"
              class="input-full-width"
              required="true"
              placeholder="Ex. 123-456789012"
              :class="{
                'p-invalid': newOperationSubmitted && invalid.operation_m_awb,
              }"
            />
            <small
              class="p-invalid"
              v-if="newOperationSubmitted && invalid.operation_m_awb"
              >Please complete this field.</small
            ><br /><br />
          </div>
          <div class="p-field">
            <label for="operation_h_awb">(H)AWB</label>
            <br />
            <InputText
              id="operation_h_awb"
              v-model="newOperation.operation_h_awb"
              class="input-full-width"
              required="true"
              placeholder="Ex. ABC12345678"
            /><br /><br />
          </div>
          <template #footer>
            <Button
              v-if="!load_creation"
              label="Cancel"
              icon="pi pi-times"
              class="p-button-text"
              @click="hideDialog"
            />
            <Button
              v-if="!load_creation"
              label="Save"
              icon="pi pi-check"
              class="p-button-text"
              @click="saveNewOperation"
            />
            <ProgressSpinner
              v-else
              style="width: 50px; height: 50px"
              strokeWidth="8"
              fill="#EEEEEE"
              animationDuration=".5s"
            /> </template
        ></Dialog>

        <Dialog
          :baseZIndex="2222"
          :visible.sync="deleteOperationDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span v-if="operation">
              Are you sure you want to delete this data?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteOperationDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSelectedOperation"
            /> </template
        ></Dialog>

        <Dialog
          :baseZIndex="2222"
          :visible.sync="closeOperationDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span v-if="operation">
              Are you sure you want to close this Operation?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="closeOperationDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="closeSelectedOperation"
            /> </template
        ></Dialog>

        <Dialog
          :baseZIndex="2222"
          :visible.sync="openOperationDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span v-if="operation">
              Are you sure you want to open this Operation?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="openOperationDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="openSelectedOperation"
            /> </template
        ></Dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { Auth } from "aws-amplify";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Toast from "primevue/toast";
import InputText from "primevue/inputtext";
import Toolbar from "primevue/toolbar";
import RadioButton from "primevue/radiobutton";
import InputNumber from "primevue/inputnumber";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Textarea from "primevue/textarea";
import Avatar from "primevue/avatar";
import Tag from "primevue/tag";
import InputMask from "primevue/inputmask";
import Vue from "vue";
import Dropdown from "primevue/dropdown";
import ProgressSpinner from "primevue/progressspinner";
import Calendar from "primevue/calendar";
import InputSwitch from "primevue/inputswitch";
import Checkbox from "primevue/checkbox";
import { setTimeout } from "timers";
export default {
  name: "login-page",
  bodyClass: "login-page",

  data() {
    return {
      filter_by_eta_range: "",
      selected_range_eta: "",
      operations: [],
      createOperationDialog: false,
      deleteOperationDialog: false,
      closeOperationDialog: false,
      openOperationDialog: false,
      operation: {},
      newOperation: {
        operation_dispatch: "",
        shipper_id: "",
        company_id: "",
        expat_id: "",
        operation_company_tag: "",
        operation_ata: "",
        operation_m_awb: "",
        operation_h_awb: "",
        operation_traduction: false,
        operation_pre_alerted: false,
        operation_status_arrival: "Transito",
        operation_endorsed: false,
        operation_imported: false,
        operation_delivery: "",
        operation_destination: "",
        operation_direction: "",
        operation_status_delivery: "Pendiente",
        operation_status_invoiced_browne: true,
        operation_document_number: 0,
        operation_agent_total_to_pay: 0,
        operation_agent_total_to_pay_currency_type: "$",
        operation_status_invoiced_client: false,
        operation_invoice_or_debit_note: "",
        operation_invoice_or_debit_note_type: "",
        operation_total_to_pay: 0,
        operation_total_to_pay_currency_type: "$",
        operation_perrot: 0,
        operation_perrot_total_to_pay: 0,
        operation_perrot_total_to_pay_currency_type: "$",
        operation_cost: 0,
        operation_cost_currency_type: "$",
      },
      filters: {},
      newOperationSubmitted: false,
      columns: [],
      selected_columns: [],
      expandedRows: [],
      sorted_by: {
        shipper_details_shipper_name: "",
        operation_id: "",
        operation_dispatch: "",
        company_details_company_name: "",
        expat_details_expat_name: "",
        operation_ata: "",
        operation_m_awb: "",
        operation_h_awb: "",
      },
      principal_data_table_loading: true,
      editingPrincipalRows: [],
      editingImportRows: [],
      editingPostSalesRows: [],
      editingAccountingRows: [],
      shippers: [],
      companies: [],
      selected_shipper_id: "",
      company_id_to_edit: "",
      expat_loaded: false,
      status_arrival_dropdown: [
        {
          value: "Arribado",
          label: "Arribado",
        },
        {
          value: "Transito",
          label: "Transito",
        },
      ],
      status_delivery_dropdown: [
        {
          value: "Entregado",
          label: "Entregado",
        },
        {
          value: "Pendiente",
          label: "Pendiente",
        },
      ],
      can_show_actions: false,
      invalid: {
        operation_m_awb: false,
        operation_h_awb: false,
        shipper_id: false,
        company_id: false,
        expat_id: false,
        operation_ata: false,
        operation_company_tag: false,
      },
      load_creation: false,
      create_tag: false,
      edit_tag: false,
      edit_operation_agent_total_to_pay_currency_type: "$",
      edit_operation_total_to_pay_currency_type: "$",
      filter_by_operation_status: "Abierta",
      dropdown_operation_status: [
        {
          label: "Cerradas",
          value: "Cerrada",
        },
        {
          label: "Abiertas",
          value: "Abierta",
        },
        {
          label: "Todas",
          value: "Todas",
        },
      ],
      dropdown_operation_invoice_or_debit_note_type: [
        {
          label: "INVOICE",
          value: "INVOICE",
        },
        {
          label: "DEBIT NOTE",
          value: "DEBIT NOTE",
        },
        {
          label: "OTHERS",
          value: "OTHERS",
        },
      ],
      excel_loaded: true,
      excel_cost_loaded: true,
      profile: "",
      show_expat_to_add: false,
      dropdown_filter_by_company: [],
      filter_by_company: "",
      dropdown_filter_by_expat: [],
      filter_by_expat: "",
      filter_expat_loaded: false,
      dolar_validation_error: false,
      clp_validation_error: false,
      clp_validation2_error: false,
      clp_validation3_error: false,
      clp_validation4_error: false,
      clp_validation5_error: false,
    };
  },
  created() {
    this.columns = [
      { field: "operation_id", header: "ID" },
      { field: "operation_dispatch", header: "ORDER" },
      { field: "shipper_id", header: "SHIPPER" },
      { field: "company_id", header: "COMPANY NAME" },
      { field: "expat_id", header: "EXPAT NAME" },
      { field: "operation_ata", header: "ETA" },
      { field: "operation_m_awb", header: "MAWB" },
      { field: "operation_h_awb", header: "HAWB" },
      { field: "operation_status", header: "STATUS" },
      { field: "operation_traduction", header: "TRANSLATION" },
      { field: "operation_pre_alerted", header: "PRE ALERTED" },
      { field: "operation_status_arrival", header: "IMPORT STATUS" },
      { field: "operation_endorsed", header: "ENDORSED" },
      { field: "operation_imported", header: "IMPORTED" },
      { field: "operation_delivery", header: "DELIVER DATE" },
      { field: "operation_destination", header: "DESTINATION" },
      { field: "operation_direction", header: "ADDRESS" },
      { field: "operation_status_delivery", header: "SHIPMENT STATUS" },
      { field: "operation_status_invoiced_browne", header: "AGENCY INVOICED" },
      { field: "operation_document_number", header: "BROKER INVOICE DOCUMENT" },
      {
        field: "operation_agent_total_to_pay",
        header: "BROKER COST",
      },
      { field: "operation_perrot", header: "INLAND INVOICE NUMBER" },
      {
        field: "operation_perrot_total_to_pay",
        header: "INLAND COST",
      },
      {
        field: "operation_cost",
        header: "OTHERS COST",
      },
      {
        field: "operation_status_invoiced_client",
        header: "BILLED",
      },
      {
        field: "operation_invoice_or_debit_note",
        header: "INVOICE NUMBER",
      },
      {
        field: "operation_invoice_or_debit_note_type",
        header: "INVOICE TYPE",
      },
      { field: "operation_total_to_pay", header: "TOTAL INVOICE CLIENT COST" },
      { field: "operation_dolar_profit", header: "EXCHANGE RATE" },
      { field: "operation_profit", header: "PROFIT" },
      { field: "created_by", header: "Creado por" },
      { field: "created_at", header: "Fecha Creacion" },
      { field: "updated_by", header: "Acualizado por" },
      { field: "updated_at", header: "Fecha Actualizacion" },
      { field: "actions", header: "Acciones" },
      { field: "editPrincipal", header: "Edit" },
      { field: "editImport", header: "Edit" },
      { field: "editPostSales", header: "Edit" },
      { field: "editAccounting", header: "Edit" },
    ];
    this.selected_columns = this.columns;
    this.originalRows = {};
  },
  async mounted() {
    const { attributes } = await Auth.currentAuthenticatedUser();
    let email = attributes["email"];
    this.getUser(email);
    this.getOperations();
    this.getShippers();
    this.getCompanies();
    this.getExpats();
    this.getFilterCompanies();
    this.getFilterExpats();
  },
  methods: {
    operationInvoiceOrDebitNoteTypeInput(input) {
      if (input == "INVOICE") {
        this.edit_operation_total_to_pay_currency_type = "$";
      } else if (input == "DEBIT NOTE") {
        this.edit_operation_total_to_pay_currency_type = "USD";
      }
    },
    getUser(email) {
      let token = localStorage.getItem("idToken");
      this.axios
        .get(
          `${process.env.VUE_APP_USERS}`,
          {
            params: {
              depth: true,
              user_email: email,
            },
          },
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          this.profile = res.data[0]["profile_details"]["profile_name"];
          // console.log(this.profile);
        })
        .catch((error) => {
          // console.log(error);
        });
    },
    selectedRangeEta() {
      if (this.selected_range_eta[0] && this.selected_range_eta[1]) {
        this.filter_by_eta_range = this.selected_range_eta;
        this.getOperations();
        try {
          document
            .querySelector(
              "#app > div > div > div > div > div.p-datatable-striped.p-datatable-sm.p-datatable.p-component.p-datatable-scrollable > div.p-datatable-header > div > div > div:nth-child(4) > span > button"
            )
            .click();
        } catch (error) {}
      }
    },
    dolarValidation(data) {
      if (data.match(/^\d+(?:\.\d{1,2})?$/)) {
        this.dolar_validation_error = false;
      } else {
        this.dolar_validation_error = true;
      }
    },
    clpValidation(data) {
      if (data.match(/^\d+(?:,\d{1,2})?$/)) {
        this.clp_validation_error = false;
      } else {
        this.clp_validation_error = true;
      }
    },
    clpValidation2(data) {
      if (data.match(/^[0-9]*$/)) {
        this.clp_validation2_error = false;
      } else {
        this.clp_validation2_error = true;
      }
    },
    clpValidation3(data) {
      if (data.match(/^[0-9]*$/)) {
        this.clp_validation3_error = false;
      } else {
        this.clp_validation3_error = true;
      }
    },
    clpValidation4(data) {
      if (data.match(/^[0-9]*$/)) {
        this.clp_validation4_error = false;
      } else {
        this.clp_validation4_error = true;
      }
    },
    clpValidation5(data) {
      if (data.match(/^[0-9]*$/)) {
        this.clp_validation5_error = false;
      } else {
        this.clp_validation5_error = true;
      }
    },
    clearInput(operation_id, column, value) {
      if (value.length <= 1 || value.length === undefined) {
        for (let index = 0; index < this.operations.length; index++) {
          const element = this.operations[index];
          if (element.operation_id == operation_id) {
            this.operations[index][`${column}`] = "";
            break;
          }
        }
      }
    },
    clearRangeEta() {
      this.filter_by_eta_range = "";
      this.getOperations();
    },
    generateExcelCostByShipper() {
      let token = this.getToken();
      this.excel_cost_loaded = false;
      this.axios
        .post(
          `${process.env.VUE_APP_OPERATIONS}/cost_excel`,
          { operations: this.operations },
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          this.$toast.add({
            severity: "success",
            summary: "Exported Data",
            detail: "The data has been successfully exported.",
            life: 5000,
          });
          Object.assign(document.createElement("a"), {
            target: "_blank",
            href: res.data.path,
          }).click();
        })
        .catch((error) => {
          // console.log(error);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail:
              "An error occurred while generating the excel, try again later.",
            life: 5000,
          });
        })
        .finally(() => {
          this.excel_cost_loaded = true;
        });
    },
    generateExcel() {
      let token = this.getToken();
      this.excel_loaded = false;
      this.axios
        .post(
          `${process.env.VUE_APP_OPERATIONS}/excel`,
          { operations: this.operations },
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          this.$toast.add({
            severity: "success",
            summary: "Exported Data",
            detail: "The data has been successfully exported.",
            life: 5000,
          });
          Object.assign(document.createElement("a"), {
            target: "_blank",
            href: res.data.path,
          }).click();
        })
        .catch((error) => {
          // console.log(error);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail:
              "An error occurred while generating the excel, try again later.",
            life: 5000,
          });
        })
        .finally(() => {
          this.excel_loaded = true;
        });
    },
    change_operation_agent_total_to_pay_currency_type(currency) {
      if (currency == "$") {
        this.edit_operation_agent_total_to_pay_currency_type = "USD";
      } else if (currency == "USD") {
        this.edit_operation_agent_total_to_pay_currency_type = "$";
      }
    },
    change_operation_total_to_pay_currency_type(currency) {
      if (currency == "$") {
        this.edit_operation_total_to_pay_currency_type = "USD";
      } else if (currency == "USD") {
        this.edit_operation_total_to_pay_currency_type = "$";
      }
    },
    createTag() {
      if (!this.create_tag) {
        this.newOperation.operation_company_tag = "";
      }
    },
    getShippers() {
      let token = this.getToken();
      this.axios
        .get(`${process.env.VUE_APP_SHIPPERS}`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          let result_shippers = res.data;
          this.shippers = [];
          result_shippers.forEach((element) => {
            this.shippers.push({
              label: element.shipper_name,
              value: element.shipper_id,
            });
          });
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {});
    },
    getCompanies() {
      let token = this.getToken();
      this.axios
        .get(`${process.env.VUE_APP_COMPANIES}?company_is_master=false`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          let result_companies = res.data;
          this.companies = [];
          result_companies.forEach((element) => {
            this.companies.push({
              label: element.company_name,
              value: element.company_id,
            });
          });
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          if (this.operations.length > 0) {
            this.principal_data_table_loading = false;
          }
        });
    },
    getFilterCompanies() {
      let token = this.getToken();
      this.axios
        .get(`${process.env.VUE_APP_COMPANIES}?company_is_master=false`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          let result_companies = res.data;
          this.dropdown_filter_by_company = [];
          result_companies.forEach((element) => {
            this.dropdown_filter_by_company.push({
              label: element.company_name,
              value: element.company_id,
            });
          });
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {});
    },
    getExpatsToAdd() {
      this.expat_loaded = false;
      this.show_expat_to_add = false;
      let token = this.getToken();
      this.axios
        .get(
          `${process.env.VUE_APP_EXPATS}?&company_id=${this.newOperation.company_id}`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          // console.log(res.data);
          let result_expats = res.data;
          this.expats = [];
          result_expats.forEach((element) => {
            this.expats.push({
              label: element.expat_name,
              value: element.expat_id,
            });
          });
          this.expat_loaded = true;
          this.show_expat_to_add = true;
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          if (this.operations.length > 0) {
            this.principal_data_table_loading = false;
          }
        });
    },
    getExpatsToEdit() {
      this.expat_loaded = false;
      let token = this.getToken();
      this.axios
        .get(
          `${process.env.VUE_APP_EXPATS}?&company_id=${this.company_id_to_edit}`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          // console.log(res.data);
          let result_expats = res.data;
          this.expats = [];
          result_expats.forEach((element) => {
            this.expats.push({
              label: element.expat_name,
              value: element.expat_id,
            });
          });
          this.expat_loaded = true;
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          if (this.operations.length > 0) {
            this.principal_data_table_loading = false;
          }
        });
    },
    getFilterExpats() {
      let token = this.getToken();
      let filter = "";
      if (this.filter_by_company) {
        filter = `company_id=${this.filter_by_company}`;
      }
      this.axios
        .get(`${process.env.VUE_APP_EXPATS}?${filter}`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          let result_expats = res.data;
          this.dropdown_filter_by_expat = [];
          result_expats.forEach((element) => {
            this.dropdown_filter_by_expat.push({
              label: element.expat_name,
              value: element.expat_id,
            });
          });
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          this.getOperations();
        });
    },
    getExpats() {
      this.expat_loaded = false;
      let token = this.getToken();
      this.axios
        .get(`${process.env.VUE_APP_EXPATS}`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          let result_expats = res.data;
          this.expats = [];
          result_expats.forEach((element) => {
            this.expats.push({
              label: element.expat_name,
              value: element.expat_id,
            });
          });
          this.expat_loaded = true;
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          if (this.operations.length > 0) {
            this.principal_data_table_loading = false;
          }
        });
    },
    setsortPrincipalDataTable(sort_data, sort_value) {
      Object.keys(this.sorted_by).forEach((key) => {
        if (key == sort_data) {
          this.sorted_by[key] = sort_value;
          let is_asc = sort_value == "DESC" ? true : false;
          if (this.sorted_by[key] != "") {
            this.sortOperations(key, is_asc);
          } else {
            this.getOperations();
          }
        } else {
          this.sorted_by[key] = "";
        }
      });
    },
    sortOperations(sort_by, is_asc) {
      this.principal_data_table_loading = true;
      let token = this.getToken();
      let filters = `sort=${sort_by}&asc=${is_asc}&depth=true&operation_status=${this.filter_by_operation_status}`;
      if (this.filter_by_eta_range) {
        filters += `&range_eta=${this.filter_by_eta_range}`;
      }
      this.axios
        .get(`${process.env.VUE_APP_OPERATIONS}?${filters}`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          this.operations = res.data;
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          setTimeout(() => {
            this.can_show_actions = true;
            this.principal_data_table_loading = false;
          }, 200);
        });
    },
    sortPrincipalDataTable(sort_by, sort_data, sort_value) {
      // console.log(sort_by, sort_data, sort_value);
      if (sort_value == "") {
        sort_value = "ASC";
        this.setsortPrincipalDataTable(sort_data, sort_value);
      } else if (sort_value == "ASC") {
        sort_value = "DESC";
        this.setsortPrincipalDataTable(sort_data, sort_value);
      } else if (sort_value == "DESC") {
        sort_value = "";
        this.setsortPrincipalDataTable(sort_data, sort_value);
      }
    },
    clpFormat(value) {
      return parseInt(value).toLocaleString("es-CL");
    },
    eeuuFormat(value) {
      return parseFloat(value).toLocaleString("en-US");
    },
    filterCompanySelected() {
      this.getFilterExpats();
    },
    filterExpatSelected() {
      this.getOperations();
    },
    getOperations() {
      this.principal_data_table_loading = true;
      let local_filter_by_operation_status = !this.filter_by_operation_status
        ? "Abierta"
        : this.filter_by_operation_status;
      let filters = `depth=true&operation_status=${local_filter_by_operation_status}`;
      if (this.filter_by_company) {
        filters += `&company_id=${this.filter_by_company}`;
        this.filter_expat_loaded = true;
      } else {
        this.filter_expat_loaded = false;
        this.filter_by_expat = "";
      }

      if (this.filter_by_expat) {
        filters += `&expat_id=${this.filter_by_expat}`;
      }
      if (this.filter_by_eta_range) {
        filters += `&range_eta=${this.filter_by_eta_range}`;
      }
      let token = this.getToken();
      this.axios
        .get(`${process.env.VUE_APP_OPERATIONS}?${filters}`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          this.operations = res.data;
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          setTimeout(() => {
            this.can_show_actions = true;
            this.principal_data_table_loading = false;
          }, 200);
        });
    },
    getToken() {
      let token = localStorage.getItem("idToken");
      return token;
    },
    formatCurrency(value) {
      return value.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },
    openNew() {
      this.newOperation = {
        operation_dispatch: "",
        shipper_id: "",
        company_id: "",
        expat_id: "",
        operation_company_tag: "",
        operation_ata: "",
        operation_m_awb: "",
        operation_h_awb: "",
        operation_traduction: false,
        operation_pre_alerted: false,
        operation_status_arrival: "Transito",
        operation_endorsed: false,
        operation_imported: false,
        operation_delivery: "",
        operation_destination: "",
        operation_direction: "",
        operation_status_delivery: "Pendiente",
        operation_status_invoiced_browne: true,
        operation_document_number: 0,
        operation_agent_total_to_pay: 0,
        operation_agent_total_to_pay_currency_type: "$",
        operation_status_invoiced_client: false,
        operation_invoice_or_debit_note: "",
        operation_invoice_or_debit_note_type: "",
        operation_total_to_pay: 0,
        operation_total_to_pay_currency_type: "$",
        operation_perrot: 0,
        operation_perrot_total_to_pay: 0,
        operation_perrot_total_to_pay_currency_type: "$",
        operation_cost: 0,
        operation_cost_currency_type: "$",
      };
      this.newOperationSubmitted = false;
      this.createOperationDialog = true;
      this.show_expat_to_add = false;
    },
    hideDialog() {
      this.createOperationDialog = false;
      this.newOperationSubmitted = false;
      this.newOperation = {
        operation_dispatch: "",
        shipper_id: "",
        company_id: "",
        expat_id: "",
        operation_company_tag: "",
        operation_ata: "",
        operation_m_awb: "",
        operation_h_awb: "",
        operation_traduction: false,
        operation_pre_alerted: false,
        operation_status_arrival: "Transito",
        operation_endorsed: false,
        operation_imported: false,
        operation_delivery: "",
        operation_destination: "",
        operation_direction: "",
        operation_status_delivery: "Pendiente",
        operation_status_invoiced_browne: true,
        operation_document_number: 0,
        operation_agent_total_to_pay: 0,
        operation_agent_total_to_pay_currency_type: "$",
        operation_status_invoiced_client: false,
        operation_invoice_or_debit_note: "",
        operation_invoice_or_debit_note_type: "",
        operation_total_to_pay: 0,
        operation_total_to_pay_currency_type: "$",
        operation_perrot: 0,
        operation_perrot_total_to_pay: 0,
        operation_perrot_total_to_pay_currency_type: "$",
        operation_cost: 0,
        operation_cost_currency_type: "$",
      };
    },
    saveNewOperation() {
      this.newOperationSubmitted = true;
      this.invalid.operation_m_awb =
        this.newOperation.operation_m_awb.trim().length == 0 ? true : false;
      this.invalid.shipper_id =
        this.newOperation.shipper_id.trim().length == 0 ? true : false;
      this.invalid.company_id =
        this.newOperation.company_id.trim().length == 0 ? true : false;
      this.invalid.expat_id =
        this.newOperation.expat_id.trim().length == 0 ? true : false;
      this.invalid.operation_ata =
        this.newOperation.operation_ata.toString().trim().length == 0
          ? true
          : false;

      this.invalid.operation_company_tag =
        this.newOperation.operation_company_tag.toString().trim().length == 0 &&
        this.create_tag
          ? true
          : false;
      if (
        !this.invalid.operation_m_awb &&
        !this.invalid.operation_h_awb &&
        !this.invalid.shipper_id &&
        !this.invalid.company_id &&
        !this.invalid.expat_id &&
        !this.invalid.operation_ata &&
        !this.invalid.operation_company_tag
      ) {
        this.createOperation();
      }
    },
    createOperation() {
      this.load_creation = true;
      let token = this.getToken();
      this.axios
        .post(`${process.env.VUE_APP_OPERATIONS}`, this.newOperation, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          this.$toast.add({
            severity: "success",
            summary: "Operation Created",
            detail: "The operation has been created successfully.",
            life: 5000,
          });
        })
        .catch((error) => {
          // console.log(error);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail:
              "An error occurred while creating the operation, please try again later.",
            life: 5000,
          });
        })
        .finally(() => {
          this.createOperationDialog = false;
          this.newOperation = {
            operation_dispatch: "",
            shipper_id: "",
            company_id: "",
            expat_id: "",
            operation_company_tag: "",
            operation_ata: "",
            operation_m_awb: "",
            operation_h_awb: "",
            operation_traduction: false,
            operation_pre_alerted: false,
            operation_status_arrival: "",
            operation_endorsed: false,
            operation_imported: false,
            operation_delivery: "",
            operation_destination: "",
            operation_direction: "",
            operation_status_delivery: "",
            operation_status_invoiced_browne: true,
            operation_document_number: 0,
            operation_agent_total_to_pay: 0,
            operation_agent_total_to_pay_currency_type: "$",
            operation_status_invoiced_client: false,
            operation_invoice_or_debit_note: "",
            operation_invoice_or_debit_note_type: "",
            operation_total_to_pay: 0,
            operation_total_to_pay_currency_type: "$",
            operation_perrot: "",
            operation_perrot_total_to_pay: 0,
            operation_perrot_total_to_pay_currency_type: "$",
            operation_cost: 0,
            operation_cost_currency_type: "$",
          };
          this.load_creation = false;
          this.getOperations();
        });
    },
    confirmDeleteOperation(operation) {
      this.operation = operation;
      this.deleteOperationDialog = true;
    },
    confirmCloseOperation(operation) {
      this.operation = operation;
      this.closeOperationDialog = true;
    },
    confirmOpenOperation(operation) {
      this.operation = operation;
      this.openOperationDialog = true;
    },
    closeSelectedOperation() {
      let operation_id = this.operation.operation_id;
      let body = this.operation;
      body.operation_status = "Cerrada";
      this.closeOperationDialog = false;
      this.updateOperation(operation_id, body);
    },
    openSelectedOperation() {
      let operation_id = this.operation.operation_id;
      let body = this.operation;
      body.operation_status = "Abierta";
      this.openOperationDialog = false;
      this.updateOperation(operation_id, body);
    },
    deleteSelectedOperation() {
      let token = this.getToken();
      this.deleteOperationDialog = false;
      this.principal_data_table_loading = true;
      this.axios
        .delete(
          `${process.env.VUE_APP_OPERATIONS}/${this.operation.operation_id}`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          // console.log(res.data);
          this.$toast.add({
            severity: "success",
            summary: "Deleted data",
            detail: "The selected data was successfully deleted.",
            life: 5000,
          });
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail:
              "An error occurred while deleting the operation, try again later.",
            life: 5000,
          });
        })
        .finally(() => {
          this.getOperations();
        });
    },
    onToggle(new_selected_columns) {
      this.principal_data_table_loading = true;
      this.selected_columns = [];
      setTimeout(() => {
        for (let index = 0; index < this.columns.length; index++) {
          const col = this.columns[index];

          for (let index = 0; index < new_selected_columns.length; index++) {
            const new_val = new_selected_columns[index];
            if (col.field == new_val.field) {
              this.selected_columns.push(col);
              break;
            }
          }
        }
        this.can_show_actions = true;
        this.principal_data_table_loading = false;
      }, 100);
    },
    onRowEditPrincipalInit(event) {
      this.originalRows[event.index] = { ...this.operations[event.index] };
      this.selected_shipper_id = event.data.shipper_id;
      this.company_id_to_edit = event.data.company_id;
      // this.expats = [];
      this.canEditAnother = false;
      this.getExpatsToEdit();
      // console.log(event);
      setTimeout(() => {
        this.displayEditButton(false);
      }, 50);
    },
    onRowEditPrincipalCancel(event) {
      // console.log(this.operations, event.index, this.originalRows[event.index]);
      // this.edit_user_profile = false;
      // Vue.set(this.operations, event.index, this.originalRows[event.index]);
      this.getOperations();
      this.displayEditButton(true);
    },
    onRowEditPrincipalSave(event) {
      // console.log(event);
      let operation_id = event.data.operation_id;
      let operation_data = event.data;
      operation_data.company_id = this.company_id_to_edit;
      this.updateOperation(operation_id, operation_data);
      this.displayEditButton(true);
    },
    displayEditButton(can_display) {
      if (can_display) {
        let edit_buttons = document.querySelectorAll(
          "button.p-row-editor-init.p-link"
        );
        for (let index = 0; index < edit_buttons.length; index++) {
          let element = edit_buttons[index];
          element.style.display = "";
        }
      } else {
        let edit_buttons = document.querySelectorAll(
          "button.p-row-editor-init.p-link"
        );
        for (let index = 0; index < edit_buttons.length; index++) {
          let element = edit_buttons[index];
          element.style.display = "none";
        }
      }
    },
    onRowEditImportInit(event) {
      this.originalRows[event.index] = { ...this.operations[event.index] };
      setTimeout(() => {
        this.displayEditButton(false);
      }, 50);
      // console.log(event);
    },
    onRowEditImportCancel(event) {
      // console.log(this.operations, event.index, this.originalRows[event.index]);
      // this.edit_user_profile = false;
      // Vue.set(this.operations, event.index, this.originalRows[event.index]);
      this.getOperations();
      this.displayEditButton(true);
    },
    onRowEditImportSave(event) {
      // console.log(event);
      let operation_id = event.data.operation_id;
      let operation_data = event.data;
      this.updateOperation(operation_id, operation_data);
      this.displayEditButton(true);
    },
    onRowEditPostSalesInit(event) {
      this.originalRows[event.index] = { ...this.operations[event.index] };
      this.edit_operation_agent_total_to_pay_currency_type =
        event.data.operation_agent_total_to_pay_currency_type;
      // console.log(event);
      setTimeout(() => {
        this.displayEditButton(false);
      }, 50);
      // console.log(event.data);
    },
    onRowEditAccountingInit(event) {
      this.originalRows[event.index] = { ...this.operations[event.index] };
      this.edit_operation_total_to_pay_currency_type =
        event.data.operation_total_to_pay_currency_type;
      // console.log(event);
      setTimeout(() => {
        this.displayEditButton(false);
      }, 50);
      // console.log(event.data);
    },
    onRowEditPostSalesCancel(event) {
      // console.log(this.operations, event.index, this.originalRows[event.index]);
      // this.edit_user_profile = false;
      // Vue.set(this.operations, event.index, this.originalRows[event.index]);
      this.dolar_validation_error = false;
      this.getOperations();
      this.displayEditButton(true);
    },
    onRowEditAccountingCancel(event) {
      // console.log(this.operations, event.index, this.originalRows[event.index]);
      // this.edit_user_profile = false;
      // Vue.set(this.operations, event.index, this.originalRows[event.index]);
      this.dolar_validation_error = false;
      this.getOperations();
      this.displayEditButton(true);
    },
    onRowEditPostSalesSave(event) {
      // console.log(event);
      let operation_id = event.data.operation_id;
      let operation_data = event.data;
      operation_data.operation_agent_total_to_pay_currency_type =
        this.edit_operation_agent_total_to_pay_currency_type;
      operation_data.operation_perrot_total_to_pay_currency_type = "$";

      if (this.dolar_validation_error) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail:
            "Please verify that the dollar value complies with the correct format.",
          life: 10000,
        });
        return;
      }
      this.updateOperation(operation_id, operation_data);
      this.displayEditButton(true);
    },
    onRowEditAccountingSave(event) {
      let operation_id = event.data.operation_id;
      let operation_data = event.data;
      operation_data.operation_cost_currency_type = "$";
      operation_data.operation_total_to_pay_currency_type =
        this.edit_operation_total_to_pay_currency_type;

      if (this.dolar_validation_error) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail:
            "Please verify that the dollar value complies with the correct format.",
          life: 10000,
        });
        return;
      }
      this.updateOperation(operation_id, operation_data);
      this.displayEditButton(true);
    },
    updateOperation(operation_id, body) {
      let token = this.getToken();
      this.principal_data_table_loading = true;
      this.axios
        .put(`${process.env.VUE_APP_OPERATIONS}/${operation_id}`, body, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          this.$toast.add({
            severity: "success",
            summary: "Updated Operation",
            detail: "The operation has been updated successfully.",
            life: 5000,
          });
        })
        .catch((error) => {
          if (error.response.status == 501) {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail:
                "Please complete the details of the expat corresponding to this Operation.",
              life: 5000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail:
                "An error occurred while updating the operation, please try again later.",
              life: 5000,
            });
          }
        })
        .finally(() => {
          this.getOperations();
        });
    },
  },
  components: {
    DataTable,
    Column,
    Toast,
    InputText,
    Toolbar,
    RadioButton,
    InputNumber,
    Button,
    Dialog,
    Textarea,
    Avatar,
    Tag,
    Dropdown,
    ProgressSpinner,
    Calendar,
    InputSwitch,
    Checkbox,
    InputMask,
  },
};
</script>
<style scoped>
.input-full-width {
  width: -webkit-fill-available !important;
}
.button-margin-right {
  margin-right: 2px;
}
.input-filter-by-status {
  width: 150px !important;
}
.input-filter-by-company {
  width: 250px !important;
}
.input-filter-by-expat {
  width: 250px !important;
}
.input-search-width {
  width: 150px !important;
}
.red-color {
  color: red;
}
</style>